import React, { useState, useCallback } from "react";
import styles from "./AuthenticationQuery.module.scss";
import ProductCertification from "./Product/index";
import Service from "./Service/index";
import Assessment from "./assessment/index";
import FIBAvenue from './venue/index'
import clsx from "clsx";

const navList = [
  { value: 1, name: "产品认证证书查询" },
  { value: 2, name: "服务认证证书查询" },
  { value: 3, name: "评估评价证书查询" },
  { value: 4, name: "FIBA场地认证证书查询" },
];
const NavItem = ({ name, active, onClick }) => (
  <div
    className={clsx(styles.navItem, { [styles.active]: active })}
    onClick={onClick}
  >
    {name}
    {active && <div className={styles.underline}></div>}
  </div>
);

const AuthenticationQuery = ({ onDataSubmit,onNavChange }) => {
  const [activeKey, setActiveKey] = useState(1);
  const handleItemClick = useCallback((value) => {
    setActiveKey(value);
    onNavChange?.(value); 
  }, []);

  const handleQuerySubmit = (data) => {
    console.log("父组件接收到查询数据:", data);
    onDataSubmit(data);
  };
  return (
    <div className={styles.AuthenticationQuery}>
      {/* 查询导航 */}
      <nav className={styles.navClass}>
        {navList.map((item) => (
          <NavItem
            key={item.value}
            name={item.name}
            active={activeKey === item.value}
            onClick={() => handleItemClick(item.value)}
          />
        ))}
      </nav>
      <div className={styles.Contents}>
        {activeKey === 1 && (
          <ProductCertification onQuerySubmit={handleQuerySubmit} />
        )}
        {activeKey === 2 && <Service onQuerySubmit={handleQuerySubmit} />}
        {activeKey === 3 && <Assessment onQuerySubmit={handleQuerySubmit} />}
         {activeKey === 4 && <FIBAvenue onQuerySubmit={handleQuerySubmit} />}
      </div>
    </div>
  );
};

export default AuthenticationQuery;
